var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('draggable',_vm._g(_vm._b({attrs:{"x":""}},'draggable',Object.assign({}, _vm.$attrs,_vm.dragOptions),false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }